import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import SvgIcon from '../svg-icon/svg-icon';
import { View } from '../../helpers/icon-dictionary';
import css from './index.scss';

const ViewCourse = ({ handleOnClick }) => (
    <button className={css.viewCourse} onClick={handleOnClick} >
        <div className={css.icon}>
            <SvgIcon icon={View} />
        </div>
    </button>
);

ViewCourse.propTypes = {
    handleOnClick: PropTypes.func
};

export default styleable(css)(ViewCourse);



// WEBPACK FOOTER //
// ./app/components/view-course/index.js